import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';

const SLOT_ID = 'SLOT_ID';

export function Slot(props) {
  const getContentDetails = () => {
    if (props.rotor && props.solution) {
      return {
        src: props.image.rotorSolution,
        alt: 'rotor-solution',
      };
    } else if (props.rotor) {
      return {
        src: props.image.rotor,
        alt: 'rotor',
      };
    } else if (props.solution) {
      return {
        src: props.image.solution,
        alt: 'solution',
      };
    } else {
      return null;
    }
  };

  const onDragStart = (event) => {
    event.dataTransfer.setData(SLOT_ID, props.id);
  };

  const renderContent = () => {
    let content = getContentDetails();
    if (content) {
      return (
        <div
          className={`${props.className}_tube`}
          draggable={props.contentDraggable}
          onDragStart={onDragStart}>
          <Image
            src={content.src}
            alt={content.alt}
            className={`${props.className}_tube_image`}
          />
        </div>
      );
    } else {
      return null;
    }
  };

  const onDragOver = (event) => event.preventDefault();

  const onDrop = (event) => {
    const slotID = parseInt(event.dataTransfer.getData(SLOT_ID));
    props.onTubeDrop({
      sourceIndex: slotID,
      targetIndex: props.id,
    });
  };

  return (
    <div onDragOver={onDragOver} onDrop={onDrop} className={props.className}>
      {renderContent()}
    </div>
  );
}

Slot.propTypes = {
  /**
   * boolean to set if the content of Slot should be draggable
   */
  contentDraggable: PropTypes.bool,
  /**
   * Unqique Id to reference the slot;
   */
  id: PropTypes.number,
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * Type of Tube placed in the slot
   */
  tubeType: PropTypes.oneOf(['PCR', '', 'NON_PCR']),
  /**
   * Boolean specify if slot has solution
   */
  solution: PropTypes.bool,
  /**
   * Boolean to specify if slot has rotor
   */
  rotor: PropTypes.bool,
  /**
   * Funciton to invoke when a tube is dropped in slot
   */
  onTubeDrop: PropTypes.func,
  /**
   * Images to render for [Rotor, Solution and Rotor+Solution]
   */
  image: PropTypes.shape({
    /**
     * Image to render for Rotor
     */
    rotor: PropTypes.string,
    /**
     * Image to render for solution
     */
    solution: PropTypes.string,
    /**
     * Image to render for Rotor+soltuion combo
     */
    rotorSolution: PropTypes.string,
  }),
};

Slot.defaultProps = {
  contentDraggable: true,
};
